import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
export function BoxContainer(props) {
    const { children } = props, sxProps = __rest(props, ["children"]);
    return _jsx(Box, { sx: sxProps, children: children });
}
//# sourceMappingURL=BoxContainer.js.map